"use client";

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/new/button";
import { ChevronDownIcon, Heading1Icon, Heading2Icon, Heading3Icon, TypeIcon } from "lucide-react";
import { Editor } from "@tiptap/react";

export const BlockFormatPopover = ({ editor }: { editor: Editor | null }) => {
	if (!editor) {
		return null;
	}

	const getCurrentBlockFormat = () => {
		if (editor.isActive("heading", { level: 1 })) return "Heading 1";
		if (editor.isActive("heading", { level: 2 })) return "Heading 2";
		if (editor.isActive("heading", { level: 3 })) return "Heading 3";
		return "Normal";
	};

	const blockFormatOptions = [
		{
			label: "Normal",
			icon: TypeIcon,
			onClick: () => editor.chain().focus().setParagraph().run(),
		},
		{
			label: "Heading 1",
			icon: Heading1Icon,
			onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
		},
		{
			label: "Heading 2",
			icon: Heading2Icon,
			onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
		},
		{
			label: "Heading 3",
			icon: Heading3Icon,
			onClick: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
		},
	];

	const currentBlock = blockFormatOptions.find(
		(option) => option.label === getCurrentBlockFormat()
	);

	const handleBlockFormatClick = (label: string) => {
		blockFormatOptions.find((option) => option.label === label)?.onClick();
		editor?.chain().focus().run();
	};

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button variant="ghost" size="sm" className="flex h-8 items-center gap-2 px-2">
					{currentBlock?.icon && <currentBlock.icon className="h-4 w-4" />}
					<span className="text-xs font-medium">{currentBlock?.label}</span>
					<ChevronDownIcon className="h-4 w-4" />
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-48 p-1">
				<div className="flex flex-col">
					{blockFormatOptions.map((option) => (
						<Button
							key={option.label}
							variant="ghost"
							size="sm"
							onClick={() => handleBlockFormatClick(option.label)}
							className="flex items-center justify-start gap-2 px-2 py-1.5 text-sm"
						>
							<option.icon className="h-4 w-4" />
							{option.label}
						</Button>
					))}
				</div>
			</PopoverContent>
		</Popover>
	);
};
